import { config } from 'src/utils/config';
import { getStandardHeaders, performFetchWithLogging } from '../utils/helpers';
import { FetchResult } from 'src/types/TApiQueries';
import type { AgentSummaryResponse, ToolCallFilters, ToolCallPage } from 'src/types/AgentActivity';

const BASE = `${config.hostUrl}/api/v1/ai/tool-calls`;

export function toolCallQuery(filters: ToolCallFilters, extra: Record<string, string | number | undefined> = {}) {
  const params = new URLSearchParams();
  Object.entries({ ...filters, ...extra }).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '' || value === false) return;
    params.set(key, String(value));
  });
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

export async function getToolCalls(
  accessToken: string,
  filters: ToolCallFilters,
  cursor?: number,
  limit = 50,
): Promise<FetchResult<ToolCallPage>> {
  return performFetchWithLogging<ToolCallPage>(`${BASE}${toolCallQuery(filters, { cursor, limit })}`, {
    method: 'GET',
    headers: getStandardHeaders(accessToken),
    credentials: 'include',
  });
}

export async function getToolCallSummary(
  accessToken: string,
  filters: ToolCallFilters,
): Promise<FetchResult<AgentSummaryResponse>> {
  return performFetchWithLogging<AgentSummaryResponse>(`${BASE}/summary${toolCallQuery(filters)}`, {
    method: 'GET',
    headers: getStandardHeaders(accessToken),
    credentials: 'include',
  });
}
